import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '../store/useAuthStore';

interface ProtectedRouteProps {
    allowedRoles?: ('student' | 'avulso' | 'admin' | 'adm' | 'corretor' | 'professor' | 'secretaria')[];
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ allowedRoles }) => {
    const { isAuthenticated, user } = useAuthStore();

    if (!isAuthenticated || !user) {
        return <Navigate to="/login" replace />;
    }

    // Validação de Role (Para admin x aluno)
    if (allowedRoles && user.role && !allowedRoles.includes(user.role)) {
        if (user.role === 'admin' || user.role === 'adm' || user.role === 'corretor' || user.role === 'professor' || user.role === 'secretaria') {
            return <Navigate to="/admin" replace />;
        }
        return <Navigate to="/student" replace />;
    }

    return <Outlet />;
};
